


















































































/* eslint-disable @typescript-eslint/no-explicit-any */
import G_090_ZaikoIdoIraiEntry_ChildActionsBtn from '@/components/G_kaigai/G_090_ZaikoIdoIraiEntry_ChildActionsBtn.vue';
import { Color, Flg, JotaiKb } from '@/constants/constants';
import { getDefaultPagerInfo } from '@/utils/utils';
import Vue from 'vue';

export default Vue.extend<any, any, any, any>({
  name: 'G_090_ZaikoIdoIraiEntry_Table',
  components: {
    G_090_ZaikoIdoIraiEntry_ChildActionsBtn,
  },
  props: {
    search: {
      type: String,
      default: '',
    },
    items: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    Color,
    Flg,
    JotaiKb,
    headers: [
      {
        text: '依頼日',
        value: 'zaikoIdoIraiEntryYmd',
        width: 100,
        sortable: true,
      },
      {
        text: '依頼№',
        value: 'zaikoIdoIraiNo',
        width: 90,
        sortable: true,
        class: 'text-end',
        cellClass: 'text-end',
      },
      {
        text: '状態',
        value: 'jotaiKb',
        sortable: false,
        width: 60,
      },
      {
        text: '依頼倉庫',
        value: 'nyukoSokoMei',
        width: 256,
        sortable: true,
      },
      {
        text: '納品希望日',
        value: 'nyukoKiboYmd',
        width: 115,
        sortable: true,
      },
      {
        text: '納品予定日',
        value: 'nyukoYoteiYmd',
        width: 115,
        sortable: true,
      },
      {
        text: '出庫予定日',
        value: 'shukkaYoteiYmd',
        width: 115,
        sortable: true,
      },
      {
        text: '品目（1件目）',
        value: 'himmokuMei',
        class: 'text-truncate',
        cellClass: 'text-truncate',
        width: 450,
        sortable: true,
      },
      {
        class: 'text-start',
        cellClass: 'text-start',
        text: '状態名',
        value: 'jotaiKbMei',
        sortable: true,
        width: 110,
      },
      { text: '', value: 'action', sortable: false, width: 40 },
    ],
    footerProps: {},
    options: {
      page: 1,
      itemsPerPage: 10,
      sortBy: [],
      sortDesc: [],
    },
  }),
  computed: {
    tableHeight() {
      return this.$vuetify.breakpoint.height - 332;
    },
  },
  methods: {
    customSearch(_value: any, search: string | null, item: any) {
      const filterValues = [
        item['zaikoIdoIraiEntryYmd'],
        item['zaikoIdoIraiNo'],
        item['nyukoSokoMei'],
        item['nyukoKiboYmd'],
        item['nyukoYoteiYmd'],
        item['shukkaYoteiYmd'],
        item['himmokuMei'],
        item['jotaiKbMei'],
      ];

      return filterValues.some(
        (v: any) =>
          v &&
          v
            .toString()
            .toLowerCase()
            .includes(search ? search.toLowerCase() : '')
      );
    },
  },
  mounted() {
    const pagerInfo = getDefaultPagerInfo();
    this.footerProps = pagerInfo.footerProps;
    this.options.itemsPerPage = pagerInfo.itemPerPage;
  },
});
